<template>
    <div>
        <div class="card">
            <div class="card-header">参训教师反馈问卷信息</div>
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">姓名</th>
                    <td class="text-center align-middle" style="width: 20%">{{surveyInfo.studentName}}</td>
                    <th class="text-center align-middle" style="width: 10%">院校</th>
                    <td class="text-center align-middle" style="width: 30%">{{surveyInfo.collegeName}}</td>
                    <th class="text-center align-middle" style="width: 10%">时间</th>
                    <td class="text-center align-middle" style="width: 20%">{{surveyInfo.createDateTimeString}}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="card my-3">
            <div class="card-header">客观评分项数据</div>
            <table class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 80%">反馈项</th>
                    <th class="text-center align-middle" style="width: 10%">评分</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, index) in surveyInfo.scoreDetailObject">
                    <tr>
                        <td class="text-center align-middle" :rowspan="item.content? 2: 1">{{index+1}}</td>
                        <td class="text-left align-middle">{{item.title}}</td>
                        <td class="text-center align-middle">{{item.score}}</td>
                    </tr>
                    <tr v-if="item.content">
                        <td class="text-left align-middle" colspan="2">
                            <p class="text-danger">低分项原因：</p>
                            {{item.content}}
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>

        <div class="card">
            <div class="card-header">主观评价项数据</div>
            <table class="table table-bordered mb-0">
                <tbody>
                <template v-for="(item, index) in surveyInfo.contentDetailObject">
                    <tr>
                        <th class="text-center align-middle" style="width: 10%" rowspan="2">{{index+1}}</th>
                        <th class="text-left align-middle">{{item.title}}</th>
                    </tr>
                    <tr>
                        <td class="text-left align-middle" colspan="2">
                            {{item.content}}
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
export default {
    name: "SurveyDetailView",
    props: {
        surveyId: {type: String, required: true},
    },
    data: function () {
        return {
            surveyInfo: {},
        };
    },
    mounted() {
        this.getSurveyInfo();
    },
    methods: {
        getSurveyInfo() {
            studyApi.survey.getSurveyInfo(this.surveyId).then(res => {
                let data = res.data;
                data.scoreDetailObject = JSON.parse(data.scoreDetail);
                data.contentDetailObject = JSON.parse(data.contentDetail);

                this.surveyInfo = data;
            });
        },
    }
}
</script>

<style scoped>

</style>